import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

/**
 * PageLoader - Componente de carga para lazy loading de páginas
 *
 * NOTA: Ahora usa LoadingSpinner unificado
 */
export const PageLoader: React.FC = () => {
  return (
    <LoadingSpinner size="xl" text="Cargando..." fullScreen />
  );
};
